import CurrencyFormatter from 'currency-formatter';

export default (amount, currencyCode) => {
  const currency = CurrencyFormatter.findCurrency(currencyCode);
  return CurrencyFormatter.format(amount / Math.pow(10, currency.decimalDigits), { code: currencyCode, format: '%s%v'});
};
